import React from "react";
import Section from "../Section";
import { pageTitle } from "../../helpers/PageTitle";
import BannerSectionStyle3 from "../Section/BannerSection/BannerSectionStyle3";
import './Events.scss';

// ===== EVENTS DATA =====
const eventsData = {
  image: "/images/icons/business-people-meeting-conference.jpg",
  indianBg: "/images/icons/people-taking-part-high-protocol-event.jpg",
  internationalBg: "/images/icons/network-graphic-overlay-banner-background.jpg",
  title: "UPCOMING NATIONAL & INTERNATIONAL EVENTS",
  indian: [
    "ISNPSCON 2026 - New Delhi",
    "INDSPNCON 2026 - Rishikesh",
    "NSSICON 2026 - Bhubaneswar",
    "Indian Stroke Conference 2026 - Kochi",
    "IACON 2026 - Jaipur",
    "NSI - Ahmedabad"
  ],
  international: [
    "AAN Annual Meeting 2026 - USA",
    "International Stroke Conference 2026 - USA",
    "WFNS Global Neurosurgery Conference 2026 - Dubai",
    "World Stroke Congress, Seoul - South Korea",
    "Congress of Neurological Surgeons - Washington"
  ]
};

export default function Events() {
  pageTitle(eventsData.title);

  return (
    <>
      <BannerSectionStyle3
        bgUrl="/images/about/banner_bg.jpg"
        imgUrl="/images/about/banner_img.png"
        title="UPCOMING EVENTS"
      />
      <Section topMd={40} bottomMd={40}>
        <div className="events-section">
          <h2 className="events-title">{eventsData.title}</h2>
          {/* Indian Conferences Box */}
          <div className="event-box indian">
            <h4>Indian Conferences</h4>
            <ul>
              {eventsData.indian.map((event, idx) => (
                <li key={idx}>{event}</li>
              ))}
            </ul>
          </div>
          {/* International Conferences Box */}
          <div className="event-box international">
            <h4>International Conferences</h4>
            <ul>
              {eventsData.international.map((event, idx) => (
                <li key={idx}>{event}</li>
              ))}
            </ul>
          </div>
        </div>
      </Section>
    </>
  );
}
